import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class ModalMaxRelated extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    };

    componentWillMount() {
    }

    componentDidMount() {
        this.setState({
            display_warning: this.props.display_warning
        });
    }


    componentWillReceiveProps(nextProps){
            this.setState({
                display_warning:nextProps.display_warning
            });
    }


    _close(){
        this.props.setLeave(false);
    }

    _set(){
        this.props.setLeave(true);
    }

    _renderText(item) {
        return langRegister.get("modal-maxrelated", item);
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                          {
                              salesChannelRegister.get('name')!=='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon.svg")}/>
                          }
                          {
                              salesChannelRegister.get('name')==='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon_yl.svg")}/>
                          }
                          <div>
                              {
                                  this.state.display_warning === 1 &&
                              <div className={Styles.overlayModalTitle}>
                                  {this._renderText("item_1")}
                              </div>
                              }
                              {
                                  this.state.display_warning === 2 &&
                                  <div className={Styles.overlayModalTitle}>
                                      {this._renderText("item_5")}
                                  </div>
                              }
                              {
                                  this.state.display_warning === 3 &&
                                  <div className={Styles.overlayModalTitle}>
                                      {this._renderText("item_7")}
                                  </div>
                              }
                              {
                                  this.state.display_warning === 4 &&
                                  <div className={Styles.overlayModalTitle}>
                                      {this._renderText("item_6")}
                                  </div>
                              }
                              {
                                  this.state.display_warning === 5 &&
                                  <div className={Styles.overlayModalTitle}>
                                      {this._renderText("item_8")}
                                  </div>
                              }
                              {
                                  this.state.display_warning === 6 &&
                                  <div className={Styles.overlayModalTitle}>
                                      {this._renderText("item_9")}
                                  </div>
                              }
                              {
                                  this.state.display_warning === 7 &&
                                  <div className={Styles.overlayModalTitle}>
                                      {this._renderText("item_10")}
                                  </div>
                              }
                              <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.overlayModalText}>
                                  {this._renderText("item_4")}{' '}
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => {this._set()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  ok
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalMaxRelated;


// WEBPACK FOOTER //
// ./src/components/modal-maxrelated/component.js